import { default as i18n } from "i18next";
import { initReactI18next } from "react-i18next";
import 'utils/console-prefix';
import { default as HelperLocale } from "utils/helper-locale";
import localesEN from "locales/en/translation.json";
import localesNL from "locales/nl/translation.json";
import localesManagementEN from "locales/en/management.json";
import localesManagementNL from "locales/nl/management.json";
import _ from 'lodash'

i18n
	.use( initReactI18next )
	.init({
		resources: {
			'en-GB': {
				translation: localesEN,
				management: localesManagementEN
			},
			'nl-NL': {
				translation: localesNL,
				management: localesManagementNL
			}
		},
		lng: HelperLocale.getDeviceLocale(),
		fallbackLng: 'en-GB',
		supportedLngs: [
			'en-GB',
			'nl-NL'
		],
		ns: 'translation',
		defaultNS: 'translation',
		debug: false,
		partialBundledLanguages: true,
		interpolation: {
			format: function(value, format, lng) {
				if( value !== undefined ) {
					if ( format === 'uppercase' ) {
						return value.toUpperCase();
					}
					
					if ( format === 'lowercase' ) {
						return value.toLowerCase();
					}
					
					return value;
				}
				
				return '';
			}
		}
	});

/**
 * Function for combining the current translations with new ones
 * @param result
 * @returns {any}
 */
const overwriteTranslations = ( result ) => {
	const { language, namespace, translations } = result;
	
	const current = _.get( i18n.options.resources, [ language, namespace ], {} );
	
	return _.merge( current, translations );
}

export default i18n;
